<ngx-simplebar>
    <aside [ngClass]="['user-profile', isDay ? 'morning' : 'night']">
        <div class="profile-image">
            <img [src]="userObj?.CollegeLogo ? userObj?.CollegeLogo : 'https://via.placeholder.com/100/fff'" />
        </div>
        <div class="profile-text">
            <a fxLayout="row" fxLayoutAlign="space-between center" [matMenuTriggerFor]="profile">
                <span>Hello
                    <span *ngIf="!!userInfo && !!userInfo.UsrName">{{ userInfo.UsrName}}</span>
                </span>
                <mat-icon class="ml-2">keyboard_arrow_down</mat-icon>
            </a>
            <mat-menu #profile="matMenu" xPosition="before">
                <app-profile-menu-list (profileAction)="onProfileAction($event)"></app-profile-menu-list>
            </mat-menu>
        </div>
    </aside>
    <ng-container>
        <mat-nav-list>
            <ng-container *ngFor="let menu of menuData">
                <div mat-subheader>{{ menu.AdminMenuName }}</div>
                <mat-list-item *ngFor="let submenu of menu.SubMenu">
                    <a mat-line fxLayout fxLayoutAlign="start center" *ngIf="!submenu.RoutePrefix"
                        [routerLink]="[submenu.DefaultScreenCode]" [routerLinkActive]="['selected']"
                        (click)="!isMenuOpened ? sidenav.toggle(false, 'program') : ''">
                        <mat-icon class="mr-2">{{ submenu.IconName }}</mat-icon>
                        <span>{{ submenu.AdminMenuName }}</span>
                    </a>
                    <a mat-line fxLayout fxLayoutAlign="start center" *ngIf="!!submenu.RoutePrefix"
                        [routerLink]="[submenu.RoutePrefix, 'action', submenu.DefaultScreenCode]"
                        [routerLinkActive]="['selected']"
                        (click)="!isMenuOpened ? sidenav.toggle(false, 'program') : ''">
                        <mat-icon class="mr-2">{{ submenu.IconName }}</mat-icon>
                        <span>{{ submenu.AdminMenuName }}</span>
                    </a>
                </mat-list-item>
            </ng-container>
        </mat-nav-list>
    </ng-container>
</ngx-simplebar>
<div class="sidebar-background"></div>